<template>
  <span>
    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
    <v-card class="card--flex-toolbar">
      <v-toolbar color="blue-grey lighten-5" class="elevation-0" tabs>
        <v-toolbar-title>
          <h5>Profissional/Veículo</h5>
        </v-toolbar-title>
        <v-tabs
          v-model="active"
          show-arrows
          slot="extension"
          color="grey lighten-4"
          slider-color="black"
        >
          <v-tab key="1" ripple>Profissional/Veículo</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card-text>
        <v-tabs-items v-model="active" style="min-height:180px">
          <v-tab-item key="1">
            <v-form v-model="valid">
              <v-container fluid>
                <v-layout row wrap>
                  <!-- LINHA 1, CAMPO NOME DO DEPENDENTE -->
                  <v-flex xs12 sm2>
                    <v-text-field
                      v-model="uf.id"
                      label="Código"
                      v-bind:disabled='true'
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-select
                      :items="profissional"
                      filled
                      v-model="uf.fk_profissional"
                      item-text="nome"
                      item-value="id"
                      label="Profissional"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-select
                      :items="veiculo"
                      filled
                      v-model="uf.fk_veiculo"
                      item-text="descricao"
                      item-value="id"
                      label="Veículo"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
        </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn small color="primary" @click="$router.push('/profissionaisveiculos')">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="onSaveClick()" :loading="loading">Salvar</v-btn>
      </v-card-actions>
    </v-card>
    <div style="margin:50px"></div>
  </span>
</template>
<script>
import { showFlash, showError } from '@/utils'
import profissionalveiculosService from '@/services/profissionalveiculos'
import profissionalService from '@/services/profissional'
import veiculosService from '@/services/veiculos'

export default {
  name: 'viagens',
  data () {
    return {
      uf: {},
      veiculo: [],
      profissional: [],
      searchInput: '',
      loading: false,
      valid: true,
      active: 0,
      modo: '',
      resultado: {}
    }
  },
  mounted: async function () {
    try {
      this.loading = true
      this.uf = {}
      this.veiculo = []
      this.profissional = []
      const result = await veiculosService.getByAll()
      if (result.data === undefined) {
        this.loading = false
        showError('Não localizei veículos!!!')
        return
      }
      this.veiculo = result.data
      const result1 = await profissionalService.getAllWithoutPagination()
      if (result1.data === undefined) {
        this.loading = false
        showError('Não localizei profissionais!!!')
        return
      }
      this.profissional = result1.data
      this.loading = false
      this.modo = 'I'
      return
    } catch (error) {
      showError(error)
    } finally {
      this.loading = false
    }
  },
  computed: {
    isAlterar: function () {
      return this.modo === 'A'
    }
  },
  methods: {
    async onSaveClick () {
      try {
        if (this.uf.fk_profissional === undefined) {
          showError('Profissional não localizado!!!')
          return
        }
        if (this.uf.fk_veiculo === undefined) {
          showError('Veículo não localizado!!!')
          return
        }
        await profissionalveiculosService.savePost(this.uf)
        showFlash('Salvo com sucesso')
      } catch (error) {
        showError(error)
      }
    }
  }
}
</script>
<style scoped>
.flex{
    height: 60px;
  }
</style>
